// Vendors
import { useStylesV2 } from '@kubit/web-ui-product-components';
// Constants
import { STYLES_NAME } from '../../../constants/stylesName';
const WizardStepperHook = ({ variant }) => {
    const styles = useStylesV2({
        styleName: STYLES_NAME.WIZARD_STEPPER,
        variantName: variant,
    });
    return { styles };
};
export { WizardStepperHook };
//# sourceMappingURL=wizard-stepper.hook.js.map